<template>
    <!-- 申请预存/开票 -->
    <el-card class="container" shadow="never">
        <div slot="header">
            <div class="desciconLarge"></div>
            <span class="font18"> {{ title }} </span>
        </div>
        <div v-infinite-scroll style="overflow:auto; display: flex; flex-direction: column; align-items: center; height:calc(100vh - 300px);">
            <el-form class="form" ref="form" :rules="rules" :model="form" label-width="130px" label-position="left">
                <el-form-item v-if="form.applyType == 2" label="预存类型">
                    <div>
                        <el-radio border v-model="form.prestoredType" :label="1">个人预存</el-radio>
                        <el-radio border :disabled="!userInfo.teamId" v-model="form.prestoredType" :label="2">团队预存</el-radio>
                        <span v-if="form.prestoredType == 2">预存团队：{{ userInfo.teamName }}</span>
                    </div>
                </el-form-item>
                <el-form-item v-if="form.applyType == 2" label="预存有礼">
                    <div style="display: flex;">
                        <el-checkbox-group v-model="storedCourtesyCheckbox" @change="setStoredCourtesy">
                            <el-checkbox border :label="1">平台券</el-checkbox>
                            <el-checkbox border :label="2">赠送金</el-checkbox>
                            <el-checkbox border :label="3">积分</el-checkbox>
                        </el-checkbox-group>
                        <span class="storedCourtesy-desc" v-if="form.storedCourtesy == 3">* 积分可在PC端 “积分商城” 使用</span>
		    	        <span class="storedCourtesy-desc" v-if="!form.storedCourtesy">* 若未选择预存有礼，则可参与预存转盘抽奖</span>
                    </div>
                </el-form-item>
                <el-form-item v-if="form.applyType == 2" label="业务员" prop="salesmanNameRules">
                    <div style="display: flex;">
                        <el-radio border v-model="form.ifContact" :label="2">未取得联系</el-radio>
                        <el-radio border v-model="form.ifContact" :label="1">已取得联系</el-radio>
                        <el-input placeholder="请输入业务员工号" v-show="form.ifContact == 1" v-model="form.salesmanName">
                            <template slot="prepend"><span style="color: #FF4A2B;">*</span>业务员工号</template>
                        </el-input>
                    </div>
                </el-form-item>
                <el-form-item v-if="form.applyType == 2" prop="invoiceRules">
                    <template slot="label"><span class="require-icon">*</span>开票信息</template>
                    <div class="invoice-box" v-for="(invoiceItem, invoiceIndex) in form.invoice" :key="invoiceIndex">
                        <div class="box-title">
                            <div style="display: flex; column-gap: 15px; align-items: center;">
                                <span>发票{{ invoiceIndex + 1 }}</span>
                                <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :picker-options="pickerOptions" v-model="invoiceItem.clientNeedInvoiceDate"></el-date-picker>
                            </div>
                            <div class="invoice-date">
                                <i class="el-icon-delete-solid" v-if="form.invoice.length > 1" @click="deleteInvoice(invoiceIndex)"></i>
                                <i class="el-icon-circle-plus" @click="addInvoice()"></i>
                            </div>
                        </div>
                        <table>
                            <thead>
                                <tr>
                                    <th style="width: 300px;">检测项目名称</th>
                                    <th style="width: 200px;">检测项目单价</th>
                                    <th style="width: 200px;">数量</th>
                                    <th>计量单位</th>
                                    <th>小计（元）</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(checkItem, checkItemIndex) in invoiceItem.checkItems" :key="checkItemIndex">
                                    <td>
                                        <el-input v-if="checkItem.detectionItemId == 213" placeholder="请输入自定义检测项目名称" v-model="checkItem.detectionItemName"></el-input>
                                        <el-select style="width: 100%;" filterable v-else v-model="checkItem.detectionItemId" @change="selectProject($event, invoiceIndex, checkItemIndex)">
                                            <el-option v-for="item in projectList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                        </el-select>
                                    </td>
                                    <td>
                                        <el-input-number v-if="checkItem.detectionItemId == 213" placeholder="请输入自定义检测项目单价" :min="1" :precision="2" v-model="checkItem.unitPrice" @change="setUnitPrice($event, invoiceIndex, checkItemIndex)"></el-input-number>
                                        <span v-else> {{ checkItem.unitPrice }} </span>
                                    </td>
                                    <td>
                                        <el-input-number 
                                            v-show="checkItem.detectionItemId" 
                                            v-model="checkItem.quantity" 
                                            :min="checkItem.detectionMeteringUnit == '小时' ? 0.5 : 1" 
                                            :max="1000"
                                            :step="checkItem.detectionMeteringUnit == '小时' ? 0.01 : 1" 
                                            :step-strictly="true" 
                                            @change="changeQuantity(invoiceIndex, checkItemIndex)">
                                        </el-input-number>
                                    </td>
                                    <td>
                                        <el-input v-if="checkItem.detectionItemId == 213" placeholder="请输入计量单位" v-model="checkItem.detectionMeteringUnit"></el-input>
                                        <span v-else> {{ checkItem.detectionMeteringUnit }} </span>
                                    </td>
                                    <td> {{ checkItem.subtotal }} </td>
                                    <td :class="{'td-button': checkItem.detectionItemId || invoiceItem.checkItems.length > 1}" @click="deleteProject(invoiceIndex, checkItemIndex)">
                                        <i class="el-icon-remove" style="font-size: 24px; color: #FF4A2B;" v-show="checkItem.detectionItemId || invoiceItem.checkItems.length > 1"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="1">
                                        <div class="invoice-total">合计： ￥{{ invoiceItem.invoiceAmount }}</div>
                                    </td>
                                    <td colspan="5">
                                        <div class="add-poject-box">
                                            <div class="add-project" @click="addProject(invoiceIndex)">
                                                <i class="el-icon-circle-plus-outline"></i>
                                                <span>新增检测项目</span>
                                            </div>
                                            <div class="add-project" @click="addProject(invoiceIndex, 213)">
                                                <i class="el-icon-circle-plus-outline"></i>
                                                <span>新增自定义检测项目</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </el-form-item>
                <el-form-item v-if="form.applyType == 1" label="开票金额">
                    <div style="color: #FF4A2B">￥{{ form.invoiceAmount }}</div>
                </el-form-item>
                <el-form-item label="开票备注">
                    <el-input placeholder="请填写开票备注" show-word-limit :maxlength="50" v-model="form.remark"></el-input>
                    <el-button style="float: right; margin-top: 15px;" type="primary" @click="openExample">示例预览</el-button>
                </el-form-item>
                <el-form-item label="发票类型">
                    <el-radio-group v-model="form.invoiceType" @input="selectInvoiceType">
                        <el-radio border :label="1">普通发票</el-radio>
                        <el-radio border :label="2">专用发票</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="accountingInformationRules">
                    <template slot="label"><span class="require-icon" v-if="accountingInformationList.includes('其他')">*</span>所需报账资料</template>
                    <div style="display: flex; column-gap: 3%;">
                        <el-checkbox-group v-model="accountingInformationList" @change="setAccountingInformation">
                            <el-checkbox border label="电子合同">电子合同</el-checkbox>
                            <el-checkbox border label="电子版测试清单">电子版测试清单</el-checkbox>
                            <el-checkbox border label="电子报告">电子报告</el-checkbox>
                            <el-checkbox border label="其他">其他</el-checkbox>
                        </el-checkbox-group>
                        <el-input style="width: 300px;" v-show="accountingInformationList.includes('其他')" placeholder="请填写其他报账资料" v-model.trim="form.otherInformation"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="发票抬头及地址" prop="invoiceInformationRules">
                    <div class="form-invoice-box">
                        <div class="form-invoice-item">
                            <el-radio border v-model="form.ifDefault" :label="1">使用默认抬头</el-radio>
                            <el-radio border v-model="form.ifDefault" :label="2">填写发票抬头</el-radio>
                        </div>
                        <el-autocomplete class="form-invoice-item" placeholder="请输入发票抬头" v-model="form.invoiceTitle" :fetch-suggestions="showInvoiceList" @select="selectInvoiceTitle">
                            <template slot="prepend"><span class="require-icon">*</span>发票抬头</template>
                        </el-autocomplete>
                        <el-input class="form-invoice-item" placeholder="请输入企业税号" v-model="form.enterpriseTaxNumber">
                            <template slot="prepend"><span class="require-icon">*</span>企业税号</template>
                        </el-input>
                        <el-input class="form-invoice-item" placeholder="请输入开户行名称" v-model="form.openBankName">
                            <template slot="prepend"><span class="require-icon" v-if="form.invoiceType == 2">*</span>开户行名称</template>
                        </el-input>
                        <el-input class="form-invoice-item" placeholder="请输入开户行账号" v-model="form.openBankAccount">
                            <template slot="prepend"><span class="require-icon" v-if="form.invoiceType == 2">*</span>开户行账号</template>
                        </el-input>
                        <el-input class="form-invoice-item" placeholder="请输入注册地址" v-model="form.registeredAddress">
                            <template slot="prepend"><span class="require-icon" v-if="form.invoiceType == 2">*</span>注册地址</template>
                        </el-input>
                        <el-input class="form-invoice-item" placeholder="请输入注册电话" v-model="form.registeredTelephone">
                            <template slot="prepend"><span class="require-icon" v-if="form.invoiceType == 2">*</span>注册电话</template>
                        </el-input>
                        <el-input class="form-invoice-item" placeholder="请输入收件人姓名" v-model="form.addressee">
                            <template slot="prepend"><span class="require-icon" v-if="form.invoiceType == 2">*</span>收件人姓名</template>
                        </el-input>
                        <el-input class="form-invoice-item" placeholder="请输入收件地址" v-model="form.deliveryAddress">
                            <template slot="prepend"><span class="require-icon" v-if="form.invoiceType == 2">*</span>收件地址</template>
                        </el-input>
                        <el-input class="form-invoice-item" placeholder="请输入收件邮箱" v-model="form.receivingContact">
                            <template slot="prepend"><span class="require-icon" v-if="form.invoiceType == 2">*</span>收件邮箱</template>
                        </el-input>
                        <el-input class="form-invoice-item" placeholder="请输入收件联系方式" v-model="form.receivingContactInformation">
                            <template slot="prepend"><span class="require-icon" v-if="form.invoiceType == 2">*</span>收件联系方式</template>
                        </el-input>
                    </div>
                </el-form-item>
            </el-form>
            <div style="display: flex; justify-content: space-around; width: 50%;">
                <el-button :loading="confirmLoading" @click="goBack">返回</el-button>
                <el-button type="primary" :loading="confirmLoading" @click="validateFormDate">提交</el-button>
            </div>
        </div>

        <!-- 申请成功弹框 -->
        <el-dialog title="温馨提示" width="30%" center :show-close="false" :close-on-click-modal="false" :visible.sync="applySuccessDialog">
            <el-result icon="success" title="申请成功">
                <template slot="extra">
                    <h3>正常开票大约需要<span style="color:#E6A23C">10～15分钟</span>，如果有疑问请联系客服</h3>
                    <h3>您也可在<span style="color:#E6A23C">我的发票</span>中查看开票进度</h3>
                    <el-button @click="backAndRefresh" type="text" style="font-size: 16px;margin-left: 29px;margin-top: 10px"><i class="el-icon-arrow-left el-icon--left"></i>返回</el-button>
                    <el-button @click="toMyInvoice()" type="text" style="font-size: 16px;margin-left: 29px;margin-top: 10px">查看我的发票<i class="el-icon-arrow-right el-icon--right"></i></el-button>
                </template>
            </el-result>
        </el-dialog>
    </el-card>
</template>

<script>
import { getClient } from "@/plugins/auth";
import { listInvoiceHead, testItemList, postInvoice, getInvoiceHeadContrastList } from "@/api/request";
import { validEnterpriseTax, validSpace } from '@/plugins/validate.js'
import dayjs from "dayjs";

export default {
    data() {
        return {
            title: '申请预存',
            confirmLoading: false,
            applySuccessDialog: false,
            userInfo: JSON.parse(getClient()),
            // 数据提交表单--------------------------------------------------------------------------
            form: {
				applyType: 2, //申请类型  1申请开票  2申请预存
				prestoredType: 1, //预存类型  1个人预存  2团队预存
				storedCourtesy: undefined, //预存有礼
                ifContact: 2,//是否与业务员取得联系 1 是  2否
                salesmanName: '',//业务员工号
				invoice: [{
					clientNeedInvoiceDate: '', //开票日期
					invoiceAmount: null, //该发票总金额
					testItem: '', //检测项目
					//检测项目列表
					checkItems:[
						{
							detectionItemName: '',//设备名称
							detectionItemId: '',//设备ID
							quantity: null,//数量
					        detectionMeteringUnit: '',//检测项目计量单位
							subtotal: null,//金额
							unitPrice: null,//单价
						}
					],
				}],
				remark: '', //开票备注
				invoiceType: 1, //发票类型   1 普通发票  2 专用发票   
				payerInvoiceType: '32', //发票类型  普通发票 32  专用发票 31
				accountingInformation: '', //报账所需资料
				otherInformation: '', // 其他资料
				ifDefault: 2, //是否选择默认抬头
				invoiceTitle: '', //发票抬头
				enterpriseTaxNumber: '', //企业税号
				openBankName: '', //开户行名称
				openBankAccount: '', //开户行账号
				registeredAddress: '', //注册地址
				registeredTelephone: '', //注册电话
				addressee: '',//收件人姓名
				deliveryAddress: '',//收件地址
				receivingContact: '',//收件邮箱
				receivingContactInformation: '',//收件联系方式
			},
            // ---------------------------------------------------------------------------------------------
            storedCourtesyCheckbox: [],//选择预存有礼
            // 发票日期选择器配置项
            pickerOptions: {
                disabledDate(time) {
                    return dayjs(time.getTime()).isBefore(dayjs(), 'day')
                },
            },
            invoiceList: [], //发票抬头列表
            projectList: [], //检测项目列表 --- 用于选择框组件
            projectDetailList: [], //检测项目详情列表
            accountingInformationList: [],//所需报账资料列表
        }
    },
    computed: {
        rules() {
            const salesmanNameRules = (rule, value, callback) => {
                if(this.form.ifContact == 1 && !this.form.salesmanName) {
                    callback(new Error('业务员工号不能为空'))
                }
                callback()
            }
            const invoiceRules = (rule, value, callback) => {
                let validate = true
                let invoiceNum = 0
                let invoiceDesc = ''
                this.form.invoice.forEach((item, index) => {
                    if(validate) {
                        if(!item.clientNeedInvoiceDate) {
                            validate = false
                            invoiceNum = index + 1
                            invoiceDesc = '开票日期'
                            return
                        }
                        item.checkItems.forEach(i => {
                            if(!i.detectionItemId || !i.detectionItemName) {
                                validate = false
                                invoiceNum = index + 1
                                invoiceDesc = '检测项目名称'
                                return
                            }
                            if(!i.detectionMeteringUnit) {
                                validate = false
                                invoiceNum = index + 1
                                invoiceDesc = '计量单位'
                                return
                            }
                        })
                    }
                })
                if(validate) {
                    callback()
                } else {
                    callback(new Error(`【发票${invoiceNum}】——【${invoiceDesc}】不能为空`))
                }
            }
            const accountingInformationRules = (rule, value, callback) => {
                if(this.accountingInformationList.includes('其他') && !this.form.otherInformation) {
                    callback(new Error('【其他】报账资料不能为空'))
                } else{
                    callback()
                }
            }
            const invoiceInformationRules = (rule, value, callback) => {
                const dict = [
                    {label: '发票抬头', index: 0, key: 'invoiceTitle'},
                    {label: '企业税号', index: 1, key: 'enterpriseTaxNumber'},
                    {label: '收件邮箱', index: 2, key: 'receivingContact'},
                    {label: '开户行名称', index: 3, key: 'openBankName'},
                    {label: '开户行账号', index: 4, key: 'openBankAccount'},
                    {label: '银行地址', index: 5, key: 'registeredAddress'},
                    {label: '注册电话', index: 6, key: 'registeredTelephone'},
                    {label: '收件人姓名', index: 7, key: 'addressee'},
                    {label: '收件地址', index: 8, key: 'deliveryAddress'},
                    {label: '收件邮箱', index: 9, key: 'receivingContact'},
                    {label: '收件联系方式', index: 10, key: 'receivingContactInformation'},
                ]
                let validate = true
                let label = undefined
                dict.forEach(item => {
                    if(validate) {
                        if(item.index <= 1 && !this.form[item.key]) {
                            validate = false
                            label = item.label
                        }
                        if(item.index > 1 && this.form.invoiceType == 2 && !this.form[item.key]) {
                            validate = false
                            label = item.label
                        }
                    }
                })
                if(validate) {
                    for(const item of dict) {
                        if(validSpace(this.form[item.key])) {
                            callback(new Error(`【${item.label}】不能有空格、换行等`))
                            break
                        }
                    }
                    if(!validEnterpriseTax(this.form.enterpriseTaxNumber)) {
                        callback(new Error('请输入正确的企业税号'))
                    } else {
                        callback()
                    }
                } else {
                    callback(new Error(`【${label}】不能为空`))
                }
            }
            let obj = {}
            switch(this.form.applyType) {
                case 1:
                    obj = {
                        invoiceInformationRules: [{ validator: invoiceInformationRules, trigger: 'blur' }],
                    }
                break
                case 2:
                    obj = {
                        salesmanNameRules: [{ validator: salesmanNameRules, trigger: 'blur' }],
                        invoiceRules: [{ validator: invoiceRules, trigger: 'blur' }],
                        accountingInformationRules: [{ validator: accountingInformationRules, trigger: 'blur' }],
                        invoiceInformationRules: [{ validator: invoiceInformationRules, trigger: 'blur' }],
                    }
                break
            }
            return obj
        },
    },
    watch: {
        'form.ifContact': {
            handler(newValue) {
                if(newValue == 2) {
                    this.$refs.form.clearValidate(['salesmanNameRules'])
                }
            }
        },
        'form.invoice': {
            handler() {
                if(this.form.applyType == 2) {
                    this.form.invoice.forEach(item => {
                        item.invoiceAmount = item.checkItems.reduce((sum, item) => {
                            return sum + Number(item.subtotal)
                        }, 0).toFixed(2)
                        item.testItem = item.checkItems.map(item => item.detectionItemName).join(',')
                    })
                }
            },
            immediate: true,
            deep: true,
        },
        'form.ifDefault': {
            handler(newValue) {
                if(newValue == 1) {
                    if(!this.invoiceList.length) {
                        this.$confirm('您还未添加过发票抬头，是否前往添加？', '温馨提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$router.push({
                                path: '/aboutUsIndex',
                                query: {
                                    tabIndex: '3-3',
                                }
                            })
                        }).catch(() => {
                            this.form.ifDefault = 2
                        })
                    } else {
                        const info = this.invoiceList[0]
					    this.form.invoiceTitle = info.invoiceTitle
					    this.form.enterpriseTaxNumber = info.enterpriseTaxNumber
					    this.form.receivingContact = info.receivingContact
					    this.form.openBankName = info.openBankName
					    this.form.openBankAccount = info.openBankAccount
					    this.form.registeredAddress = info.registeredAddress
					    this.form.registeredTelephone = info.registeredTelephone
					    this.form.addressee = info.addressee
					    this.form.deliveryAddress = info.deliveryAddress
					    this.form.receivingContact = info.receivingContact
					    this.form.receivingContactInformation = info.receivingContactInformation
                    }
                } else {
                    this.form.invoiceTitle = ''
					this.form.enterpriseTaxNumber = ''
					this.form.receivingContact = ''
					this.form.openBankName = ''
					this.form.openBankAccount = ''
					this.form.registeredAddress = ''
					this.form.registeredTelephone = ''
					this.form.addressee = ''
					this.form.deliveryAddress = ''
					this.form.receivingContact = ''
					this.form.receivingContactInformation = ''
                }
                this.$nextTick(() => {
                    this.$refs.form.clearValidate()
                })
            },
            immediate: true
        },
    },
    async created() {
        const projectParams = {
            ifSelfSupport: 1, //是否自营
        }
        const invoiceRes = await listInvoiceHead({clientId: this.userInfo.clientId})
        const projectRes = await testItemList(projectParams)
        this.invoiceList = invoiceRes.rows.filter(item => item.isDefault == 1)
        this.projectDetailList = projectRes.data
        this.projectList = projectRes.data.map(item => {
            return {
                label: item.detectionItemName,
                value: item.detectionItemId,
            }
        })

    },
    methods: {
        init(applyType, invoiceOrderList, invoiceAmount) {
            if(applyType == 1) {
                this.title = '申请开票'
                this.form = {
		    		applyType: 1, //申请类型  1申请开票  2申请预存
					orderInvoice: [],
					// orderInvoice:[
					// 	{
					// 		money: null,//发票金额
					// 		orderId: null,//订单ID
					// 		prepaidPayment: null,//支付方式
					// 		detectionItemName: '',//检测项目名称"
					// 		detectionMeteringUnit: '',//检测项目计量单位
					// 		quantity: null,//数量
					// 		unitPrice: null,//单价
					// 	}
					// ],
		    		invoiceAmount: null,
		    		remark: '', //开票备注
		    		invoiceType: 1, //发票类型   1 普通发票  2 专用发票   
		    		payerInvoiceType: '32', //发票类型  普通发票 32  专用发票 31
		    		accountingInformation: '', //报账所需资料
		    		otherInformation: '', // 其他资料
		    		ifDefault: 2, //是否选择默认抬头
		    		invoiceTitle: '', //发票抬头
		    		enterpriseTaxNumber: '', //企业税号
		    		receivingContact: '', //收件邮箱
		    		openBankName: '', //开户行名称
		    		openBankAccount: '', //开户行账号
		    		registeredAddress: '', //注册地址
		    		registeredTelephone: '', //注册电话
                    addressee: '',//收件人姓名
				    deliveryAddress: '',//收件地址
				    receivingContact: '',//收件邮箱
				    receivingContactInformation: '',//收件联系方式
		    	}
		    	this.form.invoiceAmount = invoiceAmount
                this.form.orderInvoice = invoiceOrderList
            }
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
            })
        },
        //选择【预存有礼】
        setStoredCourtesy(e) {
            if(e.length >= 2) {
                this.form.storedCourtesy = e[e.length - 1]
                this.storedCourtesyCheckbox = [e[e.length - 1]]
            } else if (e.length == 1) {
                this.form.storedCourtesy = e[0]
                this.storedCourtesyCheckbox = [e[0]]
            } else {
                this.form.storedCourtesy = undefined
                this.storedCourtesyCheckbox = []
            }
        },
        //【添加发票】
        addInvoice() {
            const obj = {
				clientNeedInvoiceDate: '', //开票日期
				invoiceAmount: null, //该发票总金额
				testItem: '', //检测项目
				//检测项目列表
				checkItems:[
					{
						detectionItemName: '',//设备名称
						detectionItemId: '',//设备ID
						quantity: null,//数量
				        detectionMeteringUnit: '',//检测项目计量单位
						subtotal: null,//金额
						unitPrice: null,//单价
					}
				],
			}
            this.form.invoice.push(obj)
        },
        //【删除发票】
        deleteInvoice(invoiceIndex) {
            if(this.form.invoice.length == 1) {
                this.form.invoice[0].detectionItemName = ''
                this.form.invoice[0].detectionItemId = ''
                this.form.invoice[0].quantity = null
                this.form.invoice[0].detectionMeteringUnit = ''
                this.form.invoice[0].subtotal = null
                this.form.invoice[0].unitPrice = null
            } else {
                this.form.invoice.splice(invoiceIndex, 1)
            }
        },
        //选择【检测项目】
        selectProject(e, invoiceIndex, checkItemIndex) {
            const filterList = this.form.invoice[invoiceIndex].checkItems.filter((item, index) => index !== checkItemIndex)
            if(filterList.some(item => item.detectionItemId == e)) {
                this.form.invoice[invoiceIndex].checkItems[checkItemIndex].detectionItemId = undefined
                this.form.invoice[invoiceIndex].checkItems[checkItemIndex].detectionItemName = undefined
                this.form.invoice[invoiceIndex].checkItems[checkItemIndex].quantity = 1
                this.form.invoice[invoiceIndex].checkItems[checkItemIndex].unitPrice = undefined
                this.form.invoice[invoiceIndex].checkItems[checkItemIndex].detectionMeteringUnit = undefined
                this.form.invoice[invoiceIndex].checkItems[checkItemIndex].subtotal = 0
                this.$message.warning('请勿选择相同的检测项目')
                return
            }
            const project = this.projectDetailList.find(item => item.detectionItemId == e)
            this.form.invoice[invoiceIndex].checkItems[checkItemIndex].detectionItemId = project.detectionItemId
            this.form.invoice[invoiceIndex].checkItems[checkItemIndex].detectionItemName = project.detectionItemName
            this.form.invoice[invoiceIndex].checkItems[checkItemIndex].quantity = 1
            this.form.invoice[invoiceIndex].checkItems[checkItemIndex].unitPrice = project.unitPrice.toFixed(2)
            this.form.invoice[invoiceIndex].checkItems[checkItemIndex].detectionMeteringUnit = project.detectionMeteringUnit
            this.form.invoice[invoiceIndex].checkItems[checkItemIndex].subtotal = project.unitPrice.toFixed(2)
        },
        //设置【自定义检测项目单价】
        setUnitPrice(e, invoiceIndex, checkItemIndex) {
            const unitPrice = e || 0
            this.form.invoice[invoiceIndex].checkItems[checkItemIndex].unitPrice = unitPrice
            this.form.invoice[invoiceIndex].checkItems[checkItemIndex].subtotal = (unitPrice * this.form.invoice[invoiceIndex].checkItems[checkItemIndex].quantity).toFixed(2)
        },
        //更改【检测项目】数量
        changeQuantity(invoiceIndex, checkItemIndex) {
            this.$nextTick(() => {
                const quantity = this.form.invoice[invoiceIndex].checkItems[checkItemIndex].quantity || 0
                const unitPrice = this.form.invoice[invoiceIndex].checkItems[checkItemIndex].unitPrice || 0
                this.form.invoice[invoiceIndex].checkItems[checkItemIndex].subtotal = (quantity * unitPrice).toFixed(2)
            })
        },
        //添加【检测项目】
        addProject(invoiceIndex, detectionItemId) {
            const obj = {
                detectionItemName: '',//设备名称
				detectionItemId: detectionItemId,//设备ID
				quantity: null,//数量
				detectionMeteringUnit: '',//检测项目计量单位
				subtotal: null,//金额
				unitPrice: null,//单价
            }
            if(detectionItemId) {
                obj.quantity = 1
                obj.subtotal = 1
                obj.unitPrice = 1
            }
            this.form.invoice[invoiceIndex].checkItems.push(obj)
        },
        //删除【检测项目】
        deleteProject(invoiceIndex, checkItemIndex) {
            if(this.form.invoice[invoiceIndex].checkItems.length == 1) {
                this.form.invoice[invoiceIndex].checkItems[0].detectionItemName = ''
                this.form.invoice[invoiceIndex].checkItems[0].detectionItemId = ''
                this.form.invoice[invoiceIndex].checkItems[0].quantity = null
                this.form.invoice[invoiceIndex].checkItems[0].detectionMeteringUnit = ''
                this.form.invoice[invoiceIndex].checkItems[0].subtotal = null
                this.form.invoice[invoiceIndex].checkItems[0].unitPrice = null
            } else {
                this.form.invoice[invoiceIndex].checkItems.splice(checkItemIndex, 1)
            }
        },
        //选择【发票类型】
        selectInvoiceType(value) {
            this.form.payerInvoiceType = value == 1 ? '32' : '31'
        },
        //选择【报账资料】
        setAccountingInformation() {
            const flag = this.accountingInformationList.includes('其他')
            if(!flag) {
                this.form.otherInformation = ''
            }
            this.form.accountingInformation = this.accountingInformationList.filter(item => item != '其他').join(',')
        },
        // 展示【发票抬头】列表
        async showInvoiceList(queryString, cb) {
            try {
                if(queryString) {
                    const res = await getInvoiceHeadContrastList({invoiceTitle: queryString})
                    const results = res.rows.map(item => {
                        item.value = item.invoiceTitle
                        return item
                    })
                    cb(results)
                } else {
                    cb([])
                }
            }
            catch(err) {
                console.log(err)
            }
        },
        //选择【发票抬头】
        selectInvoiceTitle(data) {
            this.form.invoiceTitle = data.invoiceTitle
			this.form.enterpriseTaxNumber = data.enterpriseTaxNumber
			this.form.receivingContact = data.receivingContact
			this.form.openBankName = data.openBankName
			this.form.openBankAccount = data.openBankAccount
			this.form.registeredAddress = data.registeredAddress
			this.form.registeredTelephone = data.registeredTelephone
			this.form.addressee = data.addressee
			this.form.deliveryAddress = data.deliveryAddress
			this.form.receivingContact = data.receivingContact
			this.form.receivingContactInformation = data.receivingContactInformation
        },
        //返回上一页
        goBack() {
            this.$emit('goBack')
        },
        //校验表单必填项目
        validateFormDate() {
            this.confirmLoading = true
            this.$refs.form.validate(valid => {
                if(valid) {
                    this.confirmForm()
                } else {
                    this.confirmLoading = false
                }
            })
        },
        //【提交申请】
        confirmForm() {
            const list = [
				'invoiceTitle',
				'enterpriseTaxNumber',
				'receivingContact',
				'openBankName',
				'openBankAccount',
				'registeredAddress',
				'registeredTelephone',
				'addressee',
				'deliveryAddress',
				'receivingContact',
				'receivingContactInformation',
			]
			list.forEach(item => {
				if(this.form[item]) {
					this.form[item].replace(/[\s\r\n]/g, '')
				}
			})
            postInvoice(this.form).then(() => {
                this.applySuccessDialog = true
                this.confirmLoading = false
            }).catch(() => {
                this.confirmLoading = false
            })
        },
        //返回并刷新
        backAndRefresh() {
            this.applySuccessDialog = false
            this.$emit('backAndRefresh')
        },
        //前往我的发票
        toMyInvoice () {
            this.$router.push({
                path: "/aboutUsIndex",
                query: {type: 13, tabIndex: '3-2',tabName: '我的发票' }
            });
        },
        // 开票示例预览
        openExample() {
            const url = 'https://pstatic.navi-sci.cn/applicationPre/invoice_Example_row.png'
            window.open(url, '_blank')
        },
    },
}
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
}
.title {
    font-size: 18px;
    font-weight: 600;
}
.el-icon-delete-solid {
    cursor: pointer; 
    font-size: 30px; 
    color: #FF4A2B;
}
.el-icon-circle-plus {
    cursor: pointer; 
    font-size: 30px; 
    color: #4d6fff;
}
.form .form-invoice-box .form-invoice-item ::v-deep .el-input-group__prepend {
    width: 100px;
    text-align: center;
}
.require-icon {
    color: #FF4A2B;
}
table {
    width: 100%;
    border-collapse: collapse; /* 合并边框 */
    margin: 10px 0;
}
th, td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
}
th {
    background-color: #f2f2f2;
}
tr:last-child {
    background-color: #f2f2f2;
}
tr:hover {
    background-color: #84B7F930; /* 悬停高亮 */
}
tr:last-child:hover {
    background-color: #f2f2f2; /* 取消最后一行悬停高亮 */
}

.form {
    padding: 0 50px;
    .storedCourtesy-desc {
        margin-left: 30px;
        font-size: 16px;
        color: #5CC300;
    }
    .invoice-box {
        margin-bottom: 15px;
        padding: 15px;
        border: 1px solid #ddd;
        border-radius: 10px;
        .box-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 18px;
            font-weight: 600;
            .invoice-date {
                display: flex;
                column-gap: 15px;
                align-items: center;
            }
        }
        .td-button {
            cursor: pointer;
        }
        .invoice-total {
            flex: 1;
            font-size: 18px;
            font-weight: 600;
            color: #FF4A2B;
        }
        .add-poject-box {
            display: flex;
            .add-project {
                cursor: pointer;
                flex: 1;
                display: flex;
                column-gap: 15px;
                justify-content: center;
                align-items: center;
                font-size: 20px;
                color: #5D5D5D;
            }
            .add-project:hover {
                color: #84B7F9;
            }
        }
        
    }
    .form-invoice-box {
        display: flex;
        flex-wrap: wrap;
        row-gap: 30px;
        column-gap: 150px;
        .form-invoice-item {
            width: 40%;
        }
        .form-invoice-item:first-child {
            width: 100%;
        }
    }

}



</style>